import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Pathname } from 'Routes';
import RotatingLoader from 'Components/RotatingLoader';
import { AuthPage } from '../components/page';

const AutoTVLogin = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');

  useEffect(() => {
    if (!code) {
      navigate(Pathname.tvLogin, { replace: true });
      return;
    }

    // Never link straight away — hand off to the consent screen, which asks
    // the user to Allow/Decline before the code is sent.
    const targetPath = `${Pathname.tvLoginApprove}?code=${encodeURIComponent(code)}`;
    const token = localStorage.getItem('token');

    if (token) {
      navigate(targetPath, { replace: true });
    } else {
      localStorage.setItem('storedPath', targetPath);
      navigate(Pathname.authentication.newsignIn, { replace: true });
    }
  }, []);

  return (
    <AuthPage>
      <div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}>
        <RotatingLoader text="Preparing TV login..." />
      </div>
    </AuthPage>
  );
};

export default AutoTVLogin;
